import React from "react";

function Footer() {
  return (
    <>
      <footer className="page-footer font-small mt-5">
        <div className="footer-copyright text-center py-3 ">
          <a href="#!">© 2022 - AE & Team </a>
        </div>
      </footer>
    </>
  );
}

export default Footer;
